import { render, staticRenderFns } from "./PuestoRequisitos.vue?vue&type=template&id=e68cb494&scoped=true"
import script from "./PuestoRequisitos.vue?vue&type=script&lang=js"
export * from "./PuestoRequisitos.vue?vue&type=script&lang=js"
import style0 from "./PuestoRequisitos.vue?vue&type=style&index=0&id=e68cb494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68cb494",
  null
  
)

export default component.exports